<template>
    <component
        :is="component"
        v-if="component"
        :note="note"
        :locked="locked"
        :pageWidth="pageWidth"
        :pageHeight="pageHeight"
        @updatePageHistory="updatePageHistory"
        :totalPages="totalPages"
        @updateNote="updateNote"
        @activated="onActivated"
        @setSelectedElement="copySelectedElement"
        @copyElement="copyElement"
        :selectedElement="selectedElement"
        :currentNoteLayerBackground="currentNoteLayerBackground"
        @deactivated="onDeactivated"
    />
</template>
<script>
export default {
    name: 'dynamic-note-template',
    props: [
        'note',
        'locked',
        'pageWidth',
        'pageHeight',
        'totalPages',
        'selectedElement',
        'currentNoteLayerBackground'
    ],
    data() {
        return {
            component: null
        };
    },
    computed: {
        loader() {
            if (!this.note.type) {
                return () => Promise.reject();
            }
            return () => import(`./templates/${this.note.type}`);
        }
    },
    methods: {
        copyElement() {
            this.$emit('copyElement');
        },
        updateNote(note) {
            this.$emit('updateNote', note);
        },
        onActivated() {
            this.$emit('activated');
        },
        onDeactivated() {
            this.$emit('deactivated');
        },
        updatePageHistory(data) {
            this.$emit('updatePageHistory', data);
        },
        copySelectedElement(data) {
            this.$emit('setSelectedElement', data);
        }
    },
    mounted() {
        this.loader()
            .then(() => {
                this.component = () => this.loader();
            })
            .catch(() => {
                this.component = () => import('./templates/text');
            });
    }
};
</script>


// WEBPACK FOOTER //
// wrapper.vue?b261f330